import { studio410JoshFixture } from './fixtures';
import type { ClientSubjectIntelligence, ClientSubjectIntelligenceProvider } from './model';

export class FixtureClientSubjectIntelligenceProvider implements ClientSubjectIntelligenceProvider {
  constructor(private readonly fixture: ClientSubjectIntelligence | null = studio410JoshFixture) {}
  async getClientSubjectIntelligence(accountId: string, subjectId: string) {
    if (!this.fixture) return null;
    return this.fixture.account.id === accountId && this.fixture.subject.id === subjectId ? this.fixture : null;
  }
}

interface TrustedResponse { account: { name: string }; subject: { name: string; kind: string }; assertions: Array<{ assertion_type: string; structured_value: unknown }> }
export class ApiTrustedSubjectProvider {
  constructor(private readonly fetcher: typeof fetch = fetch) {}
  async get() {
    const query = new URLSearchParams({accountId:'21000000-0000-4000-8000-000000000001',subjectId:'31000000-0000-4000-8000-000000000001'});
    const fetcher = this.fetcher;
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        const response = await fetcher(`/api/development/trusted-subject-intelligence?${query}`,{credentials:'same-origin'});
        if (response.ok) return response.json() as Promise<TrustedResponse>;
      } catch { if (attempt === 1) throw new Error('Trusted subject service unavailable'); }
      if (attempt === 0) await new Promise((resolve) => setTimeout(resolve, 150));
    }
    throw new Error('Trusted subject service unavailable');
  }
}
export class HybridClientSubjectIntelligenceProvider implements ClientSubjectIntelligenceProvider {
  constructor(private readonly fixture: ClientSubjectIntelligenceProvider, private readonly trusted: ApiTrustedSubjectProvider) {}
  async getClientSubjectIntelligence(accountId: string, subjectId: string) {
    const base = await this.fixture.getClientSubjectIntelligence(accountId, subjectId); if (!base) return null;
    try {
      let trusted: TrustedResponse;
      try { trusted = await this.trusted.get(); } catch { await new Promise((resolve) => setTimeout(resolve, 100)); trusted = await this.trusted.get(); }
      const roles = trusted.assertions.filter((item) => item.assertion_type === 'professional_role').map((item) => typeof item.structured_value === 'string' ? item.structured_value : (item.structured_value as { label?: unknown })?.label).filter((value): value is string => typeof value === 'string');
      return { ...base, account: { ...base.account, name: trusted.account.name }, subject: { ...base.subject, name: trusted.subject.name, type: trusted.subject.kind, roles: roles.length ? roles : base.subject.roles }, provenance: { identityAndRoles: 'persisted-reviewed' as const, advancedIntelligence: 'demo-fixture' as const } };
    } catch {
      return { ...base, provenance: { identityAndRoles: 'demo-fixture' as const, advancedIntelligence: 'demo-fixture' as const, degraded: true } };
    }
  }
}
export const clientSubjectIntelligenceProvider = new HybridClientSubjectIntelligenceProvider(new FixtureClientSubjectIntelligenceProvider(), new ApiTrustedSubjectProvider());
